import type { JSX } from "react";

import { Flex, Image, Loader, Text } from "@mantine/core";

interface Props {
    backgroundColor?: string;
    description?: string;
    icon?: string;
}

export function ChecklistExampleDefaultState({ backgroundColor, description, icon }: Props): JSX.Element | null {
    return (
        <Flex mt="3xs" px="sm" py="xs" bg={backgroundColor ?? "transparent"} align="center" gap="3xs">
            {icon ? (
                <Image fit="scale-down" mah="2rem" maw="2rem" src={icon} />
            ) : (
                <Loader color="primary.5" size="xs" />
            )}
            <Text size="xs">{description} </Text>
        </Flex>
    );
}
